import React from "react";
import PropTypes from "prop-types";
import { Button } from "@badi/badi-components";

const ChatAction = ({
  config: { dataQa, Icon = null, label },
  onClick,
  ...buttonProps
}) => {
  return (
    <Button
      dataQa={dataQa}
      icon={Icon && <Icon />}
      onClick={onClick}
      {...buttonProps}
    >
      {label}
    </Button>
  );
};

ChatAction.propTypes = {
  config: PropTypes.shape({
    dataQa: PropTypes.string.isRequired,
    Icon: PropTypes.func,
    label: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ChatAction;
